const CABLE_KEY = "wasEverCableURL";

const isCableURL = (): boolean => {
  const currentPath = window.location.pathname.toLowerCase();
  const hasCableNow = currentPath.includes("cable");

  if (hasCableNow) {
    sessionStorage.setItem(CABLE_KEY, "true");
  }

  return hasCableNow || sessionStorage.getItem(CABLE_KEY) === "true";
};

export default isCableURL;
